import React from 'react';
import { useTranslation } from 'react-i18next';

import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import {
  menuItemStyle,
  menuTextStyle
} from '@/pages/Profile/Settings/styles.ts';

interface MenuItemProps {
  labelKey: string;
  onClick?: () => void;
}

export const MenuItem: React.FC<MenuItemProps> = ({
  labelKey,
  onClick
}: MenuItemProps) => {
  const { t } = useTranslation();

  return (
    <div key={labelKey} style={menuItemStyle} onClick={onClick}>
      <div style={{ flexGrow: 1, textAlign: 'left' }}>
        <span style={menuTextStyle}>{t(labelKey)}</span>
      </div>
      <ArrowRightShape width={14} height={14} fillColor="#C8C8CB" />
    </div>
  );
};
